import { getUTCTimeMilliseconds } from '@/fcoModules/utilities';
import { DotCMSLanguageId, dotCMSLanguageIdByLocale, TokenType } from '../constants/cms';
import { Locale } from '../constants/user';
import { getStorageItem, StorageKey } from '../store/store-utils';

export const getDotCMSLanguageIdFromLocale = (locale = Locale.EN) => dotCMSLanguageIdByLocale[locale] || DotCMSLanguageId.EN;
export const getDefaultCMSData = () => ({ url: '', token: '', expires: 0, tokenType: TokenType.PUBLIC });
export const isCMSTokenDataWellFormed = (cmsData) => cmsData && cmsData.url && cmsData.token && cmsData.expires && cmsData.tokenType;
export const isPublicCMSToken = (cmsData) => cmsData && cmsData.tokenType === TokenType.PUBLIC;
export const hasCMSTokenExpired = (cmsData) => {
    const now = getUTCTimeMilliseconds(Date.now());

    return cmsData?.expires && now >= cmsData.expires;
};
export const hasValidCachedCmsData = (userIsLoggedIn = false) => {
    const data = getStorageItem(StorageKey.CMS_DATA);

    if (!isCMSTokenDataWellFormed(data) || hasCMSTokenExpired(data)) {
        return false;
    }

    if (userIsLoggedIn) {
        return !isPublicCMSToken(data);
    }

    return isPublicCMSToken(data);
};
